export default {
  name: 'ConfirmMixin',
  data () {
    return {
      confirmDialog: false,
      confirmMethod: '',
      confirmText: '',
      confirmParam: null,
      selected: []
    }
  },
  mounted () {
    this.$on('confirmDialog', (value) => {
      this.confirmDialog = value
    })
    this.$on('confirmAction', (value) => {
      if (this.confirmMethod) {
        this[this.confirmMethod](value)
      }
    })
  },
  beforeDestroy () {
    this.$off('confirmDialog')
    this.$off('confirmAction')
  },
  methods: {
    callConfirm (method, confirmText, item) {
      this.confirmMethod = method
      this.confirmText = confirmText
      if (item || item === 0) {
        this.selected = [item]
        this.confirmParam = item
      }
      this.confirmDialog = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ConfirmMixin.js